import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import useFilterDropdownStyles from "../SharedStyles/useFilterDropdownStyles";

const useStyles = makeStyles(() => ({
  summary: {
    fontSize: 13,
    fontWeight: 600,
  },
}));

const QueueSelectCustom = ({ selectedQueueIds, onChange }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isDark = theme.mode === "dark" || theme.palette.type === "dark";
  const dropdownClasses = useFilterDropdownStyles();
  const [queues, setQueues] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queue");
        setQueues(data);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  const handleChange = (e) => onChange(e.target.value);

  const labelOf = (id) => {
    if (id === "0") return i18n.t("queueSelect.withoutQueue");
    const q = queues.find((qq) => qq.id === id);
    return q ? q.name : "";
  };

  return (
    <FormControl fullWidth size="small" variant="outlined">
      <InputLabel>{i18n.t("queueSelect.inputLabel")}</InputLabel>
      <Select
        multiple
        label={i18n.t("queueSelect.inputLabel")}
        value={selectedQueueIds || []}
        onChange={handleChange}
        MenuProps={{
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          getContentAnchorEl: null,
          classes: { paper: dropdownClasses.paper },
        }}
        renderValue={(selected) => {
          if (!selected?.length) return null;
          if (selected.length === 1) {
            return <span className={classes.summary} style={{ color: isDark ? "#e9edef" : "#0f172a" }}>{labelOf(selected[0])}</span>;
          }
          return (
            <span className={classes.summary} style={{ color: isDark ? "#e9edef" : "#0f172a" }}>
              {selected.length} {i18n.t("statusFilter.selected") || "selecionados"}
            </span>
          );
        }}
      >
        <MenuItem value="0">{i18n.t("queueSelect.withoutQueue")}</MenuItem>
        {queues.map((queue) => (
          <MenuItem key={queue.id} value={queue.id}>
            {queue.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default QueueSelectCustom;
